import { Shimmer } from '@components';
import {
  Column,
  Divider,
  LoadingContainer,
  LoadingRowWrapper,
} from '../../ActivityHistory.styles';

export const LoadingStructure = () => {
  return (
    <Column>
      <Column>
        <LoadingRowWrapper>
          <Shimmer
            style={{ height: '24px', width: '24px', borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: '20px', width: '153px', borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
        </LoadingRowWrapper>

        <LoadingRowWrapper className="lowerDiv">
          <LoadingRowWrapper>
            <Shimmer
              style={{ height: 22, width: '59px', borderRadius: 4 }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
            <Shimmer
              style={{ height: 22, width: '107px', borderRadius: 4 }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
            <Shimmer
              style={{ height: 22, width: '400px', borderRadius: 4 }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
          </LoadingRowWrapper>

          <Shimmer
            style={{ height: 22, width: '115px', borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
        </LoadingRowWrapper>
      </Column>

      <Divider height="16px" />

      <Column>
        <LoadingRowWrapper>
          <Shimmer
            style={{ height: '24px', width: '24px', borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: '20px', width: '153px', borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
        </LoadingRowWrapper>

        <LoadingRowWrapper className="lowerDiv">
          <LoadingRowWrapper>
            <Shimmer
              style={{ height: 22, width: '59px', borderRadius: 4 }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
            <Shimmer
              style={{ height: 22, width: '107px', borderRadius: 4 }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
          </LoadingRowWrapper>

          <Shimmer
            style={{ height: 22, width: '115px', borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
        </LoadingRowWrapper>

        <LoadingRowWrapper className="lowerDiv">
          <Shimmer
            style={{ height: 77, width: '100%', borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
        </LoadingRowWrapper>
        <Divider height="16px" />
      </Column>
    </Column>
  );
};

export const ActivityHistoryLoading = () => {
  return (
    <LoadingContainer>{Array(3).fill(<LoadingStructure />)}</LoadingContainer>
  );
};
